export default __webpack_public_path__ + "pi1-1QAAT/components/SocialProof/images/address-ease-79256e319e48bcb59562a0df179feece.svg";